import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { Post } from '../../utils/httpProvider';
import { POSITION_API } from '../../utils/apiUrl';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    code: yup.string().required(messageError.emptyMessage),
    name: yup.string().required(messageError.emptyMessage),
    description: yup.string().nullable()
});

const PositionAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    
    const handleCreate = async (values) => {
        setIsLoading(true);
        try {
            // Frontend validation should already trim, but let's be sure
            const payload = {
                ...values,
                code: values.code.trim().toUpperCase(),
                name: values.name.trim()
            };
            await Post(POSITION_API.ADD, null, payload);
            toast.success(messageToast.messageToastCreateSuccess);
            history.goBack();
        } catch (error) {
            toast.error(error?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm Vị trí</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        code: '',
                        name: '',
                        description: '',
                        isActive: true
                    }}
                >
                    {({ handleSubmit, handleChange, setFieldValue, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mã vị trí *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Mã vị trí"
                                        type="text"
                                        name="code"
                                        value={values.code}
                                        onChange={(e) => {
                                            setFieldValue('code', e.target.value.toUpperCase());
                                        }}
                                        isInvalid={!!errors.code}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.code}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên vị trí *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Tên vị trí"
                                        type="text"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Mô tả"
                                        as="textarea"
                                        rows={3}
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        isInvalid={!!errors.description}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.description}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Trạng thái hoạt động
                                </Form.Label>
                                <Col sm="10" className="d-flex align-items-center">
                                    <Form.Check
                                        type="switch"
                                        id="isActive-switch"
                                        name="isActive"
                                        label={values.isActive ? "Đang hoạt động" : "Ngừng hoạt động"}
                                        checked={values.isActive}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default PositionAdd;
